<template>
  <right-menu-item
    :href="addUserUrl"
    mode="ajax"
    :text="$t('Add user')"
    icon="user-add"
  />
</template>

<script>

export default {
  computed: {
    addUserUrl() {
      return this.$presenterInfo.url.split('?')[0] + "?do=editUser"
    }
  },
}
</script>

<style lang="scss" scoped></style>
